import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import LoginPage from './pages/authen-page/LoginPage';
import PasswordResetPage from './pages/authen-page/PasswordResetPage';
import SendPasswordResetInstructionPage from './pages/authen-page/SendPasswordResetInstructionPage';
import PageNotFound from './pages/not-found/NotFoundPage';
import RegisterPage from './pages/authen-page/RegisterPage';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { ApplicationRight } from './share/RightList';
import GuardedRoutes from './components/guarded-route/guarded-routes';
import { setTimezone } from './stores/timezone.store';
import PageNotAccess from './pages/not-access/PageNotAccess';
import HeaderComponent from './components/header/headerComponent';
import PaymentPage from './pages/payment-pages/PaymentPage';
import PaymentCreatePage from './pages/payment-pages/PaymentCreatePage';
import MemberShipPage from './pages/membership-pages/MemberShipPage';
import MagazinePage from './pages/magazine-pages/MagazinePage';
import ShoppingPage from './pages/shopping-pages/ShoppingPage';
import MemberShipCreatePage from './pages/membership-pages/MemberShipCreatePage';
import MagazineCreatePage from './pages/magazine-pages/MagazineCreatePage';
import ShoppingCreatePage from './pages/shopping-pages/ShoppingCreatePage';
import NewsPage from './pages/news-management-page/news-pages/NewsPage';
import NewCreatePage from './pages/news-management-page/news-pages/NewCreatePage';
import NewsPostsListPage from './pages/news-management-page/news-posts/child-pages/NewPostListPage';
import NewsPostCreateUpdatePage from './pages/news-management-page/news-posts/child-pages/NewPostCreateUpdatePage';
import NewsPostsPageMain from './pages/news-management-page/news-posts/NewsPostsPageMain';
import MemberCreatePage from './pages/member-pages/MemberCreatePage';
import MemberPage from './pages/member-pages/MemberPage';
import StaffSearchPage from './pages/staff/staff-search.page';
import StaffCreatePage from './pages/staff/staff-create.page';
import SystemSettingsContainerPage from './pages/system-settings/SystemSettingsContainerPage';
import RightsAndRolesPage from './pages/system-settings/child-pages/rights-and-roles/RightsAndRolesPage';
import { menus } from './components/navigations/menu';
import HeaderCreateComponent from './components/header/headerCreateComponent';
import { useTranslation } from 'react-i18next';
import UserDetailPage from './pages/member-pages/UserDetailPage';
import HeaderDetailComponent from './components/header/headerDetailComponent';
import MemberDetailPage from './pages/member-pages/MemberDetailPage';
import PaymentHistory from './pages/member-pages/PaymentHistory';
import MagazineUpload from './components/magazine/MagazineUpload';
import NewManagementPage from './pages/new-management-pages/NewManagementPage';
import HeaderDetailNewsComponent from './components/header/HeaderDetailNewsComponent';
import NewUpload from './components/newsManagemet/NewUpload';
import PromotionCodePage from './pages/promotion-code-management/promotion-code.page';
import EducationCourseMainPage from './pages/education-course-pages/EducationCourseMainPage';
import EducationCourseCreatePage from './pages/education-course-pages/EducationCourseCreatePage';
import EducationCourseUpload from './components/magazine/EducationCourseUpload';
import TeacherUpload from './components/magazine/TeacherUpload';
import CoursePurchasePage from './pages/course-purchase-pages/CoursePurchasePage';
import ProductMainPage from './pages/product-pages/ProductMainPage';
import NewProduct from './components/newsManagemet/NewProduct';
import ProductPurchasePage from './pages/product-purchase-pages/ProductPurchasePage';
import AdsSettingMainPage from './pages/product-pages/AdsSettingMainPage';
import FashionPage from './pages/fashion-pages/FashionPage';
import FashionUpload from './components/magazine/FashionUpload';
import AvantGardeCreativityMainPage from './pages/product-pages/AvantGardeCreativityMainPage';
import NewAvantGarde from './components/newsManagemet/NewAvantGarde';
import TechnologyDisplayPage from './pages/new-management-pages/TechnologyDisplayPage';
import TechnologyUpload from './components/newsManagemet/TechnologyUpload';
import ProductKnowledgePage from './pages/product-knowledge-pages/ProductKnowledgePage';
import ProductKnowledgeUpload from './components/productKnowledge/ProductKnowledgeUpload';
import BannerHeader from './pages/product-pages/BannerHeader';
import NewBanner from './components/newsManagemet/NewBanner';
import BannerMainPage from './pages/product-pages/BannerMainPage';
import CouponPage from './pages/coupon-pages/CouponPage';
import CouponDetailPage from './pages/coupon-pages/CouponDetailPage';
import NewCoupon from './components/newsManagemet/NewCoupon';
import EventManagementPage from './pages/event-pages/EventManagementPage';
import EventApprovalPage from './pages/event-pages/EventApprovalPage';
import EventAdmissionPage from './pages/event-pages/EventAdmissionPage';
import EventScanPage from './pages/event-pages/EventScanPage';
import EventUpload from './pages/event-pages/EventUpload';

function App() {
  const user = useSelector((state) => state.authenticatedUser);
  const timezone = useSelector((state) => state.timezone);
  const [authenticated, setAuthenticated] = useState(true);
  const [modalOpen, setModalOpen] = useState(false)
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (timezone) {
    // moment.tz.setDefault(timezone);
  }

  useEffect(() => {
    if (!user) {
      setAuthenticated(false);

      const allowPaths = ['/resetPassword', '/resetPasswordLink'];

      if (!allowPaths.includes(location.pathname)) {
        // navigate('/login');
      }
    } else {
      setAuthenticated(true);
    }
  }, [user]);


  // let token = user
  let token = localStorage.getItem("user")
  let menusAccess = user ? menus(user) : null
  const { t } = useTranslation();

  useEffect(() => {
    const allowPaths = [
      "/login",
      "/resetPasswordLink",
      "/resetPassword",
      "/register",
    ];
    if(!token) {
      if (!allowPaths.includes(location.pathname)) {
        navigate('/login');
      }
    }
    if(token) {
      if (allowPaths.includes(location.pathname)) {
        navigate('/');
      }
    }
  }, [token])

  return (
    <>
      <Routes>
        {/* <HeaderComponent pageTitle={t('User Management')} /> */}
        <Route element={!token ? <Navigate to="/login" /> : <><Outlet /></>}>
          <Route path="/" element={<Navigate to={menusAccess && menusAccess[0] && menusAccess[0].pathname ? menusAccess && menusAccess[0] && menusAccess[0].pathname : "/member"} />} />
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Member_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('User Management')} />}>
              <Route path="/member" element={<MemberPage />} />
            </Route>
            <Route>
              <Route path="/user/details" element={<UserDetailPage modalOpen={modalOpen} setModalOpen={setModalOpen}/>} />
            </Route>
            <Route>
              <Route path="/membership/details" element={<PaymentHistory modalOpen={modalOpen} setModalOpen={setModalOpen}/>} />
            </Route>
            <Route>
              <Route path="/member/details" element={<MemberDetailPage />} />
            </Route>
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Payment_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('Payment Management')} />}>
              <Route path="/payment" element={<PaymentPage />} />
            </Route>
            <Route element={<HeaderCreateComponent isHide="view" />}>
              <Route path="/payment/view" element={<PaymentCreatePage />} />
            </Route>
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Course_Purchase_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('Course Purchase')} />}>
              <Route path="/course-purchase" element={<CoursePurchasePage />} />
            </Route>
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Product_Purchase_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('Product Purchase')} />}>
              <Route path="/product-purchase" element={<ProductPurchasePage />} />
            </Route>
          </Route>
          {/* <Route element={<GuardedRoutes accessingRight={ApplicationRight.Staff_Management_Access} />}>
            <Route path="/membership" element={<MemberShipPage />} />
            <Route path="/membership/view" element={<MemberShipCreatePage />} />
          </Route> */}
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Magazine_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('Magazine Management')} />}>
              <Route path="/magazine" element={<MagazinePage />} />
            </Route>
            <Route element={<HeaderComponent pageTitle={t('Magazine Management')} isHide="view" />}>
              <Route path="/magazine/create" element={<MagazineCreatePage />} />
            </Route>
            <Route path="/magazine/upload/:id?" element={<MagazineUpload />} />
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Featured_Works_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('Featured Works')} />}>
              <Route path="/fashion" element={<FashionPage />} />
            </Route>
            <Route path="/fashion/upload/:id?" element={<FashionUpload />} />
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Featured_Works_Sub_Access} />}>
              <Route path="/avant-garde" element={<AvantGardeCreativityMainPage />} />
              <Route path="/create/avant-garde" element={<NewAvantGarde />} />
              <Route path="/avant-garde/:id?" element={<NewAvantGarde />} />
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Banner_Management_Access} />}>
              <Route path="/banner" element={<BannerMainPage />} />
              <Route path="/create/banner" element={<NewBanner />} />
              <Route path="/banner/:id?" element={<NewBanner />} />
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Technology_Display_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('Technology Display')} />}>
              <Route path="/technical-posts" element={<TechnologyDisplayPage />} />
            </Route>
            <Route>
              <Route path="/technical-posts/upload/:newStep?" element={<TechnologyUpload />} />
            </Route>
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Product_Knowledge_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('Product Knowledge')} />}>
              <Route path="/products-knowledge" element={<ProductKnowledgePage />} />
            </Route>
            <Route>
              <Route path="/products-knowledge/upload/:newStep?" element={<ProductKnowledgeUpload />} />
            </Route>
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Education_Management_Access} />}>
            {/* <Route element={<HeaderComponent pageTitle={title ? t(title) : t('Education Management')} />}> */}
              <Route path="/education-course" element={<EducationCourseMainPage />} />
            {/* </Route> */}
            <Route element={<HeaderComponent pageTitle={t('Education Management')} isHide="view" />}>
              {/* <Route path="/education-course/create" element={<EducationCourseCreatePage />} /> */}
            </Route>
            <Route path="/education-teacher/upload/:id?" element={<TeacherUpload />} />
            <Route path="/education-course/upload/:id?" element={<EducationCourseUpload />} />
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Product_Management_Access} />}>
              <Route path="/product" element={<ProductMainPage />} />
              <Route path="/create/product" element={<NewProduct />} />
              <Route path="/product/:id?" element={<NewProduct />} />
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Ads_Settings_Access} />}>
              <Route path="/ads-setting" element={<AdsSettingMainPage />} />
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.News_Posts_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('New Management')} />}>
              <Route path="/news-posts" element={<NewManagementPage />} />
            </Route>
            {/* <Route element={<HeaderComponent pageTitle={t('Magazine Management')} isHide="view" />}>
              <Route path="/magazine/create" element={<MagazineCreatePage />} />
            </Route> */}
            <Route>
              <Route path="/news/upload/:newStep?" element={<NewUpload />} />
            </Route>
          </Route>
          {/* <Route element={<GuardedRoutes accessingRight={ApplicationRight.Promotion_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('Promotion Management')} />}>
              <Route path="/promotion" element={<PromotionCodePage />} />
            </Route> */}
            {/* <Route>
              <Route path="staff/create" element={<StaffCreatePage />} />
            </Route> */}
          {/* </Route> */}
          {/* <Route element={<GuardedRoutes accessingRight={ApplicationRight.Staff_Management_Access} />}>
            <Route path="/shopping" element={<ShoppingPage />} />
            <Route path="/shopping/view" element={<ShoppingCreatePage />} />
          </Route> */}
          {/* <Route element={<GuardedRoutes accessingRight={ApplicationRight.News_Posts_Access} />}>
          <Route element={<HeaderComponent pageTitle={t('New Management')} />}>
            <Route path="/news-posts" element={<NewsPostsPageMain />}>
              <Route path="" element={<NewsPostsListPage />} />
              <Route path="create-new" element={<NewsPostCreateUpdatePage compose />} />
              <Route path="edit/:postId" element={<NewsPostCreateUpdatePage edit />} />
              <Route path="templating-from/:postId" element={<NewsPostCreateUpdatePage template />} />
            </Route>
          </Route>
          </Route> */}
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Staff_Management_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('Staff Management')} />}>
              <Route path="staff/search" element={<StaffSearchPage />} />
            </Route>
            <Route>
              <Route path="staff/create" element={<StaffCreatePage />} />
            </Route>
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Coupon_Management_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('Coupon Management')} />}>
              <Route path="/coupon" element={<CouponPage />} />
            </Route>
            <Route>
              <Route path="/coupon/details/:id" element={<CouponDetailPage />} />
            </Route>
            <Route path="/coupon/create" element={<NewCoupon />} />
          </Route>
          <Route element={<GuardedRoutes accessingRight={ApplicationRight.Event_Management_Access} />}>
            <Route path="/events" element={<EventManagementPage />} />
            <Route path="/events/upload/:id?" element={<EventUpload />} />
            <Route path="/events/:id" element={<EventApprovalPage />} />
            <Route path="/events/:id/admission" element={<EventAdmissionPage />} />
            <Route path="/events/:id/scan" element={<EventScanPage />} />
          </Route>
          {/* <Route element={<GuardedRoutes accessingRight={ApplicationRight.Staff_Management_Access} />}>
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/create" element={<NewCreatePage />} />
          </Route> */}
          {/* <Route element={<GuardedRoutes accessingRight={ApplicationRight.System_Setting_Access} />}>
            <Route element={<HeaderComponent pageTitle={t('System Management')} />}>
              <Route path="/system-settings/" element={<SystemSettingsContainerPage />}>
                <Route path="rights-and-roles" element={<RightsAndRolesPage />} />
              </Route>
            </Route>
          </Route> */}
        </Route>

        <Route element={token ? <Navigate to="/" /> : <><Outlet /></>}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/resetPasswordLink" element={<SendPasswordResetInstructionPage />} />
          <Route path="/resetPassword" element={<PasswordResetPage />} />
          <Route path="/register" element={<RegisterPage />} />
        </Route>

        <Route>
          <Route path="/404" element={<PageNotFound />} />
          <Route path="*" element={<PageNotFound />} />
        </Route>

      </Routes>
    </>
  );
}

export default App;

